import React, { useState } from 'react'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'

const channelConfig = {
  WHATSAPP: { icon: <WhatsAppIcon />, color: '#25D366', bg: '#E8F9EE' },
  SMS:      { icon: <SmsOutlinedIcon />, color: '#5B8DEF', bg: '#EBF1FD' },
  EMAIL:    { icon: <EmailOutlinedIcon />, color: '#637381', bg: '#F4F6F8' },
}

export default function TemplateCard({ template }) {
  const [expanded, setExpanded] = useState(false)
  const cfg = channelConfig[template.channel] || channelConfig.EMAIL

  return (
    <Paper sx={{ p: 2, position: 'relative', overflow: 'hidden', transition: 'box-shadow 0.2s', '&:hover': { boxShadow: '0 2px 12px rgba(0,0,0,0.08)' } }}>
      <Box sx={{ position: 'absolute', top: 0, left: 0, width: 4, height: '100%', bgcolor: cfg.color }} />

      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, pl: 1 }}>
        <Box sx={{ p: 0.75, borderRadius: 1, bgcolor: cfg.bg, display: 'flex' }}>
          {React.cloneElement(cfg.icon, { sx: { fontSize: 20, color: cfg.color } })}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant='subtitle2' sx={{ fontWeight: 700, wordBreak: 'break-word' }}>
            {template.displayName || template.templateName}
          </Typography>
          <Typography variant='caption' sx={{ color: 'text.disabled', display: 'block' }}>
            {template.templateName}
          </Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
            <Chip label={template.channel} size='small' sx={{ bgcolor: cfg.bg, color: cfg.color, fontWeight: 700 }} />
            <Chip
              label={template.status || 'ACTIVE'}
              size='small'
              sx={{
                bgcolor: template.status === 'INACTIVE' ? '#FDECEA' : '#E8F5E9',
                color: template.status === 'INACTIVE' ? '#D32F2F' : '#2E7D32',
                fontWeight: 700,
              }}
            />
            {template.applicableTo && (
              <Chip label={template.applicableTo} size='small' variant='outlined' />
            )}
            {template.provider && (
              <Chip label={template.provider} size='small' variant='outlined' sx={{ fontSize: '0.68rem' }} />
            )}
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
            {template.usageCount30d != null && (
              <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                <strong>{Number(template.usageCount30d).toLocaleString('en-IN')}</strong> sent (30d)
              </Typography>
            )}
            {template.lastUsedDate && (
              <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                Last: {template.lastUsedDate}
              </Typography>
            )}
          </Box>
        </Box>

        {template.templateText && (
          <IconButton size='small' onClick={() => setExpanded(!expanded)} sx={{ transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>
            <ExpandMoreIcon sx={{ fontSize: 18 }} />
          </IconButton>
        )}
      </Box>

      {template.templateText && (
        <Collapse in={expanded}>
          <Box sx={{ mt: 1.5, ml: 4, p: 1.5, bgcolor: '#F9FAFB', borderRadius: 1, border: '1px solid #E0E4E8' }}>
            <Typography variant='caption' sx={{ fontWeight: 600, color: 'text.secondary', display: 'block', mb: 0.5 }}>
              Template Text
            </Typography>
            <Typography variant='body2' sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6, color: 'text.primary' }}>
              {template.templateText}
            </Typography>
          </Box>
        </Collapse>
      )}
    </Paper>
  )
}
